/**
 * Creates a shallow copy of an object, excluding specified keys.
 *
 * @template T - The type of the object to omit keys from.
 * @template K - The union type of keys to exclude.
 *
 * @param {T} obj - The object from which to omit keys.
 * @param {K[]} keys - An array of keys to omit.
 *
 * @returns {Omit<T, K>} - A new object with the specified keys omitted.
 */
export const omit = <T, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> => {
  const result = { ...obj };
  for (const key of keys) {
    if (obj && Object.prototype.hasOwnProperty.call(obj, key)) {
      delete result[key];
    }
  }
  return result;
};
